export default "__VITE_ASSET__CEPLNpfq__"